import type { TranslationLanguage } from '@gitbook/api-client';
import { allTranslationLanguages, translationLanguageDescriptors } from '@gitbook/app-translations';
import { Picker } from '@gitbook/react-uikit';
import { Emoji, renderIcon } from '@gitbook/spine-react';

/**
 * Picker component for selecting a translation language.
 */
export function TranslationLanguagePicker(props: {
    value: TranslationLanguage | null;
    onChange: (value: TranslationLanguage) => void;
    skip?: TranslationLanguage | null;
}) {
    const { value, onChange, skip } = props;

    return (
        <Picker
            value={value}
            placeholder="Select language"
            items={allTranslationLanguages
                .filter((entry) => entry !== skip)
                .map((entry) => {
                    return {
                        label: translationLanguageDescriptors[entry].label,
                        value: entry,
                        icon: renderIcon(
                            <Emoji code={translationLanguageDescriptors[entry].emoji} />
                        ),
                    };
                })}
            search
            searchLabel="Select a language"
            onValueChange={onChange}
        />
    );
}
